import {
  numberUI,
  numberSchema,
  titleUI,
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';

const isNotWorkingIndicatorEnabled = formData =>
  !!formData?.form218940NotWorkingIndicator;

const isCurrentlyWorking = formData => formData?.currentlyWorking === true;

const shouldShowMonthlyIncome = formData =>
  !isNotWorkingIndicatorEnabled(formData) || isCurrentlyWorking(formData);

const legacyMonthlyIncomeUi = {
  'ui:title':
    'How much do you currently earn each month before taxes? If you’re not currently working, enter “0”',
  'ui:errorMessages': {
    pattern:
      'Enter how much you currently earn each month before taxes. If you’re not working, enter “0”.',
    required:
      'Enter how much you currently earn each month before taxes. If you’re not working, enter “0”.',
  },
};

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI('Your earned income'),
    'ui:description':
      'Enter the income you earned before taxes during the past 12 months. If you’re working now, also enter the amount you currently earn each month before taxes.',
    totalIncome: numberUI({
      title: 'In the past 12 months, how much did you earn before taxes?',
      hint: 'Enter the amount in dollars. Don’t include commas or a dollar sign.',
      setTouchedOnBlur: false,
      errorMessages: {
        pattern:
          'Enter the amount you earned in the last 12 months before taxes',
        required:
          'Enter the amount you earned in the last 12 months before taxes',
      },
    }),
    currentlyWorking: yesNoUI({
      title: 'Are you currently working?',
      tile: true,
      labels: {
        Y: 'Yes, I am currently working',
        N: 'No, I am not currently working',
      },
      descriptions: {
        Y: 'If you select “Yes”, we’ll ask how much you currently earn each month before taxes',
        N: 'We’ll record your current monthly earned income as $0',
      },
      hideIf: formData => !isNotWorkingIndicatorEnabled(formData),
      required: isNotWorkingIndicatorEnabled,
      errorMessages: {
        required:
          'Select “Yes” if you are currently working. If you’re not working, select “No”.',
      },
    }),
    monthlyIncome: {
      ...numberUI({
        title: 'How much do you currently earn each month before taxes?',
        hint: 'Enter the amount in dollars. Don’t include commas or a dollar sign.',
        setTouchedOnBlur: false,
        hideIf: formData => !shouldShowMonthlyIncome(formData),
        updateUiSchema: (_formData, fullData) =>
          isNotWorkingIndicatorEnabled(fullData)
            ? {
                'ui:title':
                  'How much do you currently earn each month before taxes?',
                'ui:errorMessages': {
                  pattern:
                    'Since you’re currently working, enter how much you earn each month before taxes.',
                  required:
                    'Since you’re currently working, enter how much you earn each month before taxes.',
                },
              }
            : legacyMonthlyIncomeUi,
        errorMessages: {
          pattern:
            'Since you’re currently working, enter how much you earn each month before taxes.',
          required:
            'Since you’re currently working, enter how much you earn each month before taxes.',
        },
      }),
      'ui:required': shouldShowMonthlyIncome,
    },
  },
  schema: {
    type: 'object',
    properties: {
      totalIncome: numberSchema,
      currentlyWorking: yesNoSchema,
      monthlyIncome: numberSchema,
    },
    required: ['totalIncome'],
  },
};
